import OATPrice from './price'

export default class Value {
  constructor({ code, name, variationPrice }) { 
    this.code = code;
    this.name = name;
    this.variationPrice = variationPrice;
  }

  get price() { 
    return new OATPrice({ prices: [this.variationPrice] });
  }
  
  static format(value) {
    return {
      code: value.code,
      name: value.title,
      variationPrice: value.price_variation
    }
  }

  static fromJSON(json) {
    return new Value({
      code: json.code,
      name: json.name,
      variationPrice: json.variationPrice
    });
  }
}